import styled from "@emotion/styled"

const Content = styled('div')(() => ({
    height: 'auto',
    width:'100%',
    display: 'flex',
    top:'100px',
    alignItems: 'center',
    flexDirection:'column',
}))

export default Content